import { useEffect } from 'react';
import fr from 'facet-rest';
import { useHistory } from 'react-router';
import { dashboardUri } from 'Consts/clientUris';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import PropTypes from 'prop-types';

// The account debit wizard is special because you may be ineligible to opt in to account debit at all.
// The wizard contains two modules, the first with the steps to allow users to opt to change their payment
// method and then a second module which just contains the finish step. If you are ineligible to
// opt in to account debit you will skip the first module entirely and just get the finish step
// which takes you to the payment screen.
export const AccountDebitFinishStepTemplate = ({ resource }) => {
  const { loadPageContentLink } = usePageContentContext();
  const history = useHistory();

  const handleNavigate = async () => {
    await resource.withRelationship(fr.relationships.paymentDetailsPage.name,
      (rel) => loadPageContentLink(rel.link('related')),
      () => history.push(dashboardUri));
  };

  useEffect(() => {
    if (resource) {
      handleNavigate();
    }
  }, [resource]);

  return null;
};

AccountDebitFinishStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
